import { LlmTositeLukuToimittajaRekisteritieto, TositteenMetatiedot } from '../../../_jaettu-lemonator/model/llm-tosite-luku-testaus'
import { LlmTositeLukuMetatiedotService, OdotettuToimittaja } from '../../../_jaettu-lemonator/service/llm-tosite-luku-metatiedot.service'

export const TOIMITTAJA_VALINTA_AUTOMAATTINEN = '__automaattinen'
export const TOIMITTAJA_VALINTA_EI_REKISTERISSA = '__ei-rekisterissa'

export const metatiedotToimittajaValinnaksi = (metatiedot: TositteenMetatiedot): string => {
  if (metatiedot.toimittajaAvain === undefined) {
    return TOIMITTAJA_VALINTA_AUTOMAATTINEN
  }
  return metatiedot.toimittajaAvain === null ? TOIMITTAJA_VALINTA_EI_REKISTERISSA : metatiedot.toimittajaAvain
}

export const toimittajaValintaMetatiedoiksi = (valinta: string): Pick<TositteenMetatiedot, 'toimittajaAvain'> => {
  if (valinta === TOIMITTAJA_VALINTA_AUTOMAATTINEN) {
    return {}
  }
  return { toimittajaAvain: valinta === TOIMITTAJA_VALINTA_EI_REKISTERISSA ? null : valinta }
}

export const kuvaaOdotettuToimittaja = (odotettu: OdotettuToimittaja, toimittajaRekisteri: LlmTositeLukuToimittajaRekisteritieto[]): string => {
  if (odotettu.peruste === 'valittu-ei-rekisterissa') {
    return `${odotettu.avain} (valittu, mutta ei enää rekisterissä – malli ei voi osua)`
  }
  if (!odotettu.avain) {
    return odotettu.peruste === 'valittu' ? 'null (valittu: ei rekisterissä)' : 'null (ei vastaavaa toimittajaa rekisterissä)'
  }
  const toimittaja = toimittajaRekisteri.find(t => t.avain === odotettu.avain)
  const nimi = toimittaja ? `${toimittaja.nimi} (#${toimittaja.numero})` : odotettu.avain
  const peruste = odotettu.peruste === 'valittu' ? 'valittu' : odotettu.peruste === 'tunnus' ? 'tunnuksella' : 'nimellä'
  return `${nimi}, ${peruste}`
}

/** Käyttää pisteytyksen kanssa samaa päättelyä (paatteleOdotettuToimittaja), jotta lomake näyttää saman lopputuloksen kuin ajo. */
export const laskeOdotettuToimittajaTeksti = (
  metatiedotService: LlmTositeLukuMetatiedotService,
  onLemonaid: boolean,
  lataa: boolean,
  toimittajaRekisteri: LlmTositeLukuToimittajaRekisteritieto[],
  metatiedot: TositteenMetatiedot,
): string => {
  if (!onLemonaid) {
    return 'Ei arvioida (ladattu tiedosto)'
  }
  if (lataa) {
    return 'Haetaan rekisteriä…'
  }
  if (!toimittajaRekisteri.length) {
    return 'Ei arvioida (rekisteri tyhjä)'
  }
  return kuvaaOdotettuToimittaja(metatiedotService.paatteleOdotettuToimittaja(metatiedot, toimittajaRekisteri), toimittajaRekisteri)
}
